'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SleepEntryDoneCtrl', SleepEntryDoneCtrl);

  /* @ngInject */
  SleepEntryDoneCtrl.$inject = ['$log', '$stateParams', '$sessionStorage', 'onboardingRouter'];

  function SleepEntryDoneCtrl($log, $stateParams, $sessionStorage, onboardingRouter) {
    var vm = this;
    vm.$onInit = function () {
      $log.debug('SleepEntryDoneCtrl onboarding activate');
      vm.day = $stateParams.day;
      vm.entry = _.get($stateParams, 'entryData.entries["' + vm.day + '"]');
      vm.average = _.get($stateParams, 'entryData.average');
    };

    vm.continue = function () {
      if ($stateParams.requirements) {
        $sessionStorage.authRequirements = _.unionWith($sessionStorage.authRequirements, $stateParams.requirements, function (o, n) {
          return o.requirementType === n.requirementType;
        });
      }

      onboardingRouter.goToNextStep({ average: vm.average }, {
        name: 'onboarding.mood.overlay'
      });
    };
  }
})();